import EntranceTableContainer from "./EntranceTableContainer";

export default EntranceTableContainer;